import { Injectable } from "@angular/core";
import {
  ActivityLogClient,
  LogCatalogCategoryVisitRequestModel,
  LogProductVisitRequestModel,
  LogSearchRequestModel,
} from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class ActivityLogService {
  constructor() {}

  logProductVisit(channelRequestId: string, sku: string): Promise<void> {
    return new ActivityLogClient().logProductVisit(
      channelRequestId,
      new LogProductVisitRequestModel({
        sku,
      }),
    );
  }

  logCatalogCategoryVisit(
    channelRequestId: string,
    catalogCategoryId: number,
  ): Promise<void> {
    return new ActivityLogClient().logCatalogCategoryVisit(
      channelRequestId,
      new LogCatalogCategoryVisitRequestModel({
        catalogCategoryId,
      }),
    );
  }

  logSearch(channelRequestId: string, term: string): Promise<void> {
    return new ActivityLogClient().logSearch(
      channelRequestId,
      new LogSearchRequestModel({
        term,
      }),
    );
  }
}
